import { render, staticRenderFns } from "./ShowCustomerCard.vue?vue&type=template&id=7ab362cf"
import script from "./ShowCustomerCard.vue?vue&type=script&lang=js"
export * from "./ShowCustomerCard.vue?vue&type=script&lang=js"
import style0 from "./ShowCustomerCard.vue?vue&type=style&index=0&id=7ab362cf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports